// extracted by mini-css-extract-plugin
export default {"button":"RoundButton_button__jC-98","white":"RoundButton_white__vtmVf"};